import { postAction, downFile } from './method'

/*样表导出*/
export const download = (data) => downFile('/afox/internal/download', { data })
/*发送触发日志*/
export const collectLog = (data) => postAction('/afox/accessLog/collectLog', { data })

export const queryStaffName = (data) =>
  postAction('/afox/authority/queryAuthUserByUserName', { data })
/*上传图片*/
const HOST = 'http://' + window.location.host
export const uploadApi = `/afox/proxy/uploadImage`
export const uploadImage = (data) => postAction(uploadApi, { data })
const videoUrl =
  process.env.NODE_ENV === 'production' ? 'https://ycapi.xfs.com' : 'https://t4.xfs.com'
export const videoUploadUrl = videoUrl + '/api/admin/abaseservice/upload-big'
